import React from "react";
import ctl from "@netlify/classnames-template-literals";

import { Container, Ntext } from "components";
import { paymentsSection } from "config/drivers";

import BottomBlur from "svgs/drivers/bottom-blur.svg";
import ScanToPay from "svgs/drivers/scan-to-pay.svg";

const { title, description } = paymentsSection;

const NombaQRPayments = () => {
  return (
    <section className={wrapperStyle}>
      <Container className={sectionStyle}>
        <ScanToPay className="max-w-[360px] lg:max-w-[540px] lg:max-h-[480px]" />
        <aside className="flex flex-col space-y-6 !mt-0">
          <Ntext
            value="QR PAYMENTS"
            color="n-flavescent"
            className="!font-bold !tracking-[3px]"
            variant="text3"
          />
          <Ntext
            value={title}
            color="primary-100"
            className="!font-medium md:!leading-[56px] !-tracking-[2px]"
            variant="h2"
          />
          <Ntext
            color="n-silver"
            value={description}
            className="md:max-w-[490px]"
            variant="text3"
          />
        </aside>
      </Container>
      <BottomBlur className={bottomBlurStyle} />
    </section>
  );
};

const bottomBlurStyle = ctl(`
  absolute
  lg:top-[800px]
  top-[400px]
  opacity-40
  w-[100vw]
  right-0
  left-0
`);

const wrapperStyle = ctl(`
  overflow-hidden
  lg:pt-[248px]
  lg:pb-[320px]
  bg-n-smoky
  pb-[200px]
  w-screen
  relative
  pt-20
`);

const sectionStyle = ctl(`
  flex
  flex-col-reverse
  lg:space-x-[84px]
  space-y-reverse
  lg:items-center
  lg:space-y-0
  lg:flex-row
  space-y-16
`);

export { NombaQRPayments };
